import { store, useAppStore, objectBounds, isOutOfBounds } from '../store/appStore';

export function ObjectList() {
  const objects = useAppStore((s) => s.objects);
  const selectedId = useAppStore((s) => s.selectedId);

  return (
    <aside className="object-list" data-testid="object-list">
      <header className="panel-header">
        <h2>Objects</h2>
        <span className="count">{objects.length}</span>
      </header>
      {objects.length === 0 && (
        <p className="empty">Upload an STL / 3MF / OBJ to begin.</p>
      )}
      <ul>
        {objects.map((o) => {
          const bb = objectBounds(o);
          const oob = isOutOfBounds(o);
          return (
            <li
              key={o.id}
              className={`${o.id === selectedId ? 'selected' : ''} ${oob ? 'oob' : ''}`}
              onClick={() => store.select(o.id)}
            >
              <div className="obj-name">{o.name}</div>
              <div className="obj-meta">
                {bb.sx.toFixed(1)} × {bb.sz.toFixed(1)} × {bb.sy.toFixed(1)} mm
                {oob ? ' · OUT OF BOUNDS' : ''}
              </div>
            </li>
          );
        })}
      </ul>
    </aside>
  );
}
